(function ($) {
    $(function () {
        if ($(".js-reset-password").length === 0) {
            return;
        }

        $('.js-password-reset-email').on('input', function () {
            $('.js-succes-reset-password').addClass('d-none');
            $('.js-error-reset-password').addClass('d-none');
        });

        $('.js-reset-password').on('submit', function (e) {
            e.preventDefault();

            var theForm = $(this);
            var data = grabFormAsObject(theForm);

            data['url'] = localize.resetpassurl;

            apiGetCall('user/pwreset', data, (error, result) => {

                if (result.error) {
                    $('.js-error-reset-password').text(result.error).removeClass('d-none');
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        $('.js-error-reset-password').addClass('d-none');
                    }, 3200);
                    return;
                }

                if (result.success === true) {
                    theForm.trigger("reset");;
                    $('.js-succes-reset-password').removeClass('d-none');
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        $('.js-succes-reset-password').addClass('d-none');
                        window.location.href = localize.loginurl;
                    }, 3200);
                }

            });

            return false;
        });
    });
})(jQuery);